import React, { useContext, useState } from 'react';
import { layoutContext } from '../CODBGame';
import './Intro.scss';
import { Scenario } from '../../data/constants';
import { Button } from 'carbon-components-react';
import { ArrowRight20 } from '@carbon/icons-react';
import { introProps } from '../Interfaces/Interface';

const Intro = (introProps: introProps) => {
  const { contents } = introProps;
  const { setCurrentScenario } = useContext(layoutContext);
  const [showRules, setShowRules] = useState(false);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showImage, setShowImage] = useState(true);
  const [showIntro] = useState(false);

  const handleClick = () => {
    if (!showRules) {
      setShowRules(true);
      setShowImage(true);
    } else {
      setShowQuestions(true);
    }
  };
  const w = window.innerWidth;
  const setImageName = () => {
    let str = '';
    if (showRules && w > 500) {
      str = 'background-2';
    } else if (w < 500) {
      if (showRules) {
        str = 'background-2';
      } else {
        str = 'background-mobile';
      }
    } else {
      str = 'background-1';
    }
    return str;
  };
  const imageName = setImageName();
  return (
    <div
      className="bx--row codb-game__intro"
      style={{
        backgroundImage: `url("${process.env.PUBLIC_ASSETS_URL}/codb-game/images/${imageName}-codb-game.png")`,
      }}
    >
      <div className="bx--col-lg-8 bx--col-md-8 bx--col-sm-4">
        <h1 className="codb-game__intro-headline">
          {showQuestions ? (
            setCurrentScenario(Scenario.questions)
          ) : showRules ? (
            <>
              <div className="codb-game__intro-headline--rules">
                <h1 className="codb-game__intro-headline--rules-title">
                  {contents.ruleTitle}
                </h1>
                <p className="codb-game__intro-headline--rules-description">
                  {contents.ruleNumber1}
                </p>
                <p className="codb-game__intro-headline--rules-description">
                  {contents.ruleNumber2}
                </p>
                <p className="codb-game__intro-headline--rules-description">
                  {contents.ruleNumber3}
                </p>
                <p className="codb-game__intro-headline--rules-description">
                  {contents.ruleNumber4}
                </p>
              </div>
            </>
          ) : !showIntro && showImage ? (
            <h1 className="codb-game__intro-headline">{contents.title}</h1>
          ) : null}
        </h1>
      </div>

      <Button
        className="codb-game__intro-cta"
        onClick={handleClick}
        renderIcon={ArrowRight20}
      >
        <p className="codb-game__intro-cta-text">{contents.button}</p>
      </Button>
    </div>
  );
};

export default Intro;
